import { req } from "@/api/api_request";

// 获取运维用户列表
export function getOperationUserList({ group_id, page, size, search }) {
  let url = `user/get-list?group_id=${group_id}`;
  if (page) {
    page += `&page=${page}`;
  }
  if (size) {
    size += `&size=${size}`;
  }
  if (search) {
    url += `&search=${search}`;
  }
  return req.get(url);
}

// 获取uuc用户列表
export function getUserListFromUUC(projectId) {
  let url = `user/get-uuc-user-list?project_id=${projectId}`;
  return req.get(url);
}

// 添加用户
export function addOperationUser(params) {
  let url = `user/add`;
  return req.post(url, params);
}

// 删除用户
export function deleteOperationUser(user_id) {
  let url = `user/delete?user_id=${user_id}`;
  return req.post(url);
}
